import Swiper from 'swiper';
import 'swiper/css';

const NossosExperts = () => {
    const components = document.querySelectorAll('[data-component="nossos_experts"]');

    components.forEach(component => {
        const swiperComponent = component.querySelector('.swiper');

        const swiper = new Swiper(swiperComponent, {
            loop: false,
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 22,
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 22,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                }
            },
        });
    })
};

export default NossosExperts;

if (document.querySelectorAll('[data-component="nossos_experts"]').length) {
    NossosExperts();
}
